import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'

interface ToastItem { id: number; message: string }
interface ToastCtx { show: (message: string) => void }

const Ctx = createContext<ToastCtx | null>(null)

/** 가장 가까운 ToastProvider 가 없으면 throw — AppShell 에서 wrap 보장 */
export function useToast(): ToastCtx {
  const v = useContext(Ctx)
  if (!v) throw new Error('useToast: ToastProvider 안에서만 사용')
  return v
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([])
  const show = useCallback((message: string) => {
    const id = Date.now() + Math.random()
    setItems((prev) => [...prev, { id, message }])
    setTimeout(() => setItems((prev) => prev.filter((x) => x.id !== id)), 2000)
  }, [])
  return (
    <Ctx.Provider value={{ show }}>
      {children}
      <div id="toast-container" style={{
        position: 'fixed', top: 16, right: 16, zIndex: 9999,
        display: 'flex', flexDirection: 'column', gap: 6, pointerEvents: 'none',
      }}>
        {items.map((it) => (
          <div key={it.id} className="toast-item" style={{
            background: 'var(--text)', color: 'var(--bg)',
            padding: '8px 14px', borderRadius: 'var(--r-md)',
            fontSize: 13, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            pointerEvents: 'auto', maxWidth: 360, wordBreak: 'break-word',
          }}>{it.message}</div>
        ))}
      </div>
    </Ctx.Provider>
  )
}
